import React from 'react';
import Header from '../../components/Layout/Header/Header';
import Footer from '../../components/Layout/Footer/Footer';
import OffWrap from '../../components/Layout/Header/OffWrap';
import SearchModal from '../../components/Layout/Header/SearchModal';
import Newsletter from '../../components/Common/Newsletter';
import SiteBreadcrumb from '../../components/Common/Breadcumb';
import CommunityMain from './CommunityMain';

// Images
import Logo from '../../assets/img/logo/logo-dark.png';
import footerLogo from '../../assets/img/logo/logo-dark.png';
import bannerbg from '../../assets/img/breadcrumbs/2.jpg';

const Community = () => {
    return (
        <React.Fragment>
            <OffWrap />
            <Header
                parentMenu='community'
                headerNormalLogo={Logo}
                headerStickyLogo={Logo}
                CanvasLogo={Logo}
                mobileNormalLogo={Logo}
                CanvasClass="right_menu_togle hidden-md"
                headerClass="full-width-header header-style1 home8-style4"
                TopBar='enable'
                TopBarClass="topbar-area home8-topbar"
                emailAddress='hello@syroltech.com'
                Location='Abuja, Nigeria'
            />

            <SiteBreadcrumb
                pageTitle="Community"
                pageName="Community"
                breadcrumbsImg={bannerbg}
            />

            <CommunityMain />

            <Newsletter
                sectionClass="rs-newsletter style1 orange-color mb--90 sm-mb-0 sm-pb-70"
                titleClass="title mb-0 white-color"
            />

            <Footer
                footerClass="rs-footer home9-style main-home"
                footerLogo={footerLogo}
                socialIconColor="black"
            />
            <SearchModal />
        </React.Fragment>
    );
}

export default Community;
